import { useState, useEffect } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

import { getCircular } from "../Service/Api.js";
import { Link } from "react-router-dom";

const CareersOpenings = () => {
  const [vacancyData, setVacancyData] = useState([]);

  const homeMenu = [
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];

  useEffect(function () {
    async function get_Vacancy_data() {
      let vacancy_details = await getCircular();
      console.log("what is vacancy_details", vacancy_details);
      let vacancy_details_Filter = vacancy_details.filter(
        function (item, index, arr) {
          return item.category === "Vacancy";
        },
      );

      setVacancyData(function (prev) {
        return vacancy_details_Filter;
      });
    }
    get_Vacancy_data();
  }, []);

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-vision.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Current Openings"
                breadEnd="Current Openings"
                breadMid="Current Openings"
              />
            </div>
          </div>
          {/* <div className="row">
            <div className="col-md-12">


          <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/current-openings.jpeg" alt="Current Openings" className="img-fluid mx-auto d-block" />

              <div
                style={{
                  border: "solid 2px #8b221a",
                  padding: "10px",
                  marginBottom: "20px",
                  width: "Max-Content",
                }}
              >
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/teacher_application.pdf"
                  target="_blank"
                >
                  Download Application Form
                </a>
              </div>
              <br></br>
              <ul className="admission-list">
                {vacancyData
                  .slice() // optional: avoid mutating state
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((item) => (
                    <li key={item._id}>
                      {item.attachments && item.attachments.length > 0 ? (
                        <Link
                          target="_blank"
                          to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                        >
                          {item.title}
                        </Link>
                      ) : (
                        <>{item.title}</>
                      )}
                    </li>
                  ))}
              </ul>

              <p>
                You can also send your CV at
                <a
                  style={{ color: "red" }}
                  href="mailto:recruitment@lotusvalleygurgaon.com"
                >
                  recruitment@lotusvalleygurgaon.com
                </a>
              </p>
            </div>
          </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default CareersOpenings;
